import { InjectionToken } from '@angular/core';
import { TaskIdentityInterface } from '@vendasta/task-manager';
import { Observable } from 'rxjs';

export const AskQuestionServiceInterfaceToken: InjectionToken<AskQuestionServiceInterface> =
  new InjectionToken<AskQuestionServiceInterface>('AskQuestionServiceInterface');

export interface AskQuestionServiceInterface {
  askQuestion(question: string, taskIdentity: TaskIdentityInterface): Observable<any>;
}
